import React, { Component } from 'react';
import {
  Carousel,
  CarouselItem,
} from 'reactstrap';
import {
  BOOTSTRAP_COLUMN_WIDTH,
} from '../../app-constants';

class CarouselWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
      animating: false,
    };
  }

  onExiting = () => {
    this.setState({ animating: true });
  };

  onExited = () => {
    this.setState({ animating: false });
  };

  getIndicatorClasses = (itemsLength) => {
    const { activeIndex } = this.state;
    const classes = ['carousel-indicators'];
    if (activeIndex === 0) classes.push('first');
    if (activeIndex === itemsLength - 1) classes.push('last');
    if (itemsLength === 2) classes.push('two-slides');
    return classes.join(' ');
  };


  next = (itemsLength) => {
    const { activeIndex, animating } = this.state;
    if (animating) return;
    const nextIndex = activeIndex === itemsLength - 1 ? 0 : activeIndex + 1;
    this.setState({ activeIndex: nextIndex });
  };

  previous = (itemsLength) => {
    const { activeIndex, animating } = this.state;
    if (animating) return;
    const nextIndex = activeIndex === 0 ? itemsLength - 1 : activeIndex - 1;
    this.setState({ activeIndex: nextIndex });
  };

  render() {
    const { RepeatableInjectedComponent, cardsPerSlide, autoPlay, items = [] } = this.props;
    const { activeIndex, animating } = this.state;
    const itemsLength = items.length;

    const slides = items.map((item, itemIndex) => (
      <CarouselItem
        onExiting={this.onExiting}
        onExited={this.onExited}
        key={itemIndex.toString()}
      >
        <div className="row">
          {item.map((card, cardIndex) => (
            <div className={`col-${BOOTSTRAP_COLUMN_WIDTH / cardsPerSlide}`} key={cardIndex.toString()}>
              <RepeatableInjectedComponent {...card} {...this.props} />
            </div>
          ))}
        </div>
      </CarouselItem>
    ));

    return (
      <div className={`carousel-wrapper col-12 px-0 ${animating ? 'carousel-animating' : ''}`}>
        <div className="row mb-4">
          {itemsLength > 1 &&
          <div
            role="button"
            tabIndex="0"
            className="carousel-control carousel-ctrl-prev td-icon icon-ui-left-arrow-thick"
            onClick={() => this.previous(itemsLength)}
          />
          }
          <div className="col px-3">
            <Carousel
              activeIndex={activeIndex}
              next={() => this.next(itemsLength)}
              previous={() => this.previous(itemsLength)}
              ride="carousel"
              interval={autoPlay}
            >
              {slides}
            </Carousel>
          </div>
          {itemsLength > 1 &&
          <div
            role="button"
            tabIndex="0"
            className="carousel-control carousel-ctrl-next td-icon icon-ui-right-arrow-thick"
            onClick={() => this.next(itemsLength)}
          />
          }
        </div>
        {itemsLength > 1 &&
        <div className="row">
          <div className="col">
            <div className={this.getIndicatorClasses(itemsLength)} />
          </div>
        </div>
        }
      </div>
    );
  }
}

export default CarouselWrapper;
